import { isWeb, styled, YStack } from "tamagui";

import { shadow } from "../../themes/token-shadow";
import { disabledInteractiveStyles } from "../interactive/styles";
import { appearVariants, pressVariants } from "../Motion/motion";

// `color: "inherit"` (not `$textDefault`) — Card is a content container, so
// color flows from inner text components rather than being forced here.
// Lets `<Body1 color="$textSecondary">` inside an interactive Card win. Web
// only: it is a CSS keyword, and the Reanimated driver rejects it as a colour.
export const cardInteractiveVariantStyles = {
  cursor: "pointer",
  ...(isWeb ? { color: "inherit" } : {}),
  hoverStyle: {
    backgroundColor: "$surface2Hover",
    borderColor: "$borderDefaultHover",
  },
  pressStyle: {
    backgroundColor: "$surface2Hover",
    borderColor: "$borderDefaultHover",
  },
} as const;

/** Internal visual base for cards — disabled overrides interactive when both apply. */
export const StyledCard = styled(YStack, {
  name: "StyledCard",
  backgroundColor: "$surface2",
  borderColor: "$borderDefault",
  variants: {
    variant: {
      outlined: { borderWidth: "$border2" },
      elevated: { borderWidth: "$border1", ...shadow.light },
      raised: { borderWidth: 0, ...shadow.subtle },
    },
    size: {
      small: { borderRadius: "$br2", padding: "$sp2" },
      medium: { borderRadius: "$br2.25", padding: "$sp2" },
      large: { borderRadius: "$br3", padding: "$sp3" },
    },
    interactive: {
      true: cardInteractiveVariantStyles,
      false: {},
    },
    press: pressVariants,
    appear: appearVariants,
    disabled: {
      true: disabledInteractiveStyles,
      false: {},
    },
  } as const,
  defaultVariants: {
    variant: "outlined",
    size: "small",
    interactive: false,
  },
});
